import React from "react";
import { useHistory } from "react-router-dom";
// import { FaLinkedinIn, FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa";

function Footer() {
  const history = useHistory();
  // const gotoPage2 = (field) => history.push(`/${field}`);


  const gotoPage2 = (field) => {
    history.push(field ? `/${field}` : "/");
  };

  return (
    <footer className="bg-[#1A1F36]">
      <div className="flex flex-col justify-start w-full h-full pt-20 pb-8 2xl:w-9/12 xl:w-11/12 xl:px-0 px-4 mx-auto">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 pb-20">
          <div>
            <img src="/assets/logo/AGRPartners-Logo.svg" alt="logo" className="w-44" />
            <p className="max-w-xs mt-4 text-base text-white">AGRPartners is on a mission to reshape the narrative around workplace happiness and wellbeing. </p>
          </div>
          <div className="grid grid-cols-1 gap-8 lg:col-span-2 sm:grid-cols-2 lg:grid-cols-3">

            <div>
              {/* <h1 className="text-2xl font-semibold text-white text-left">Resources</h1>
              <nav className="flex flex-col mt-4 space-y-2 text-base text-white">
                <h1 onClick={() => gotoPage2("")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Blog</h1>
                <div onClick={() => gotoPage2("happiness-and-wellbeing-award-2023")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">In the News</div>
                <h1 onClick={() => gotoPage2("")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Privacy Policy</h1>
                <h1 onClick={() => gotoPage2("")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">FAQ</h1>
              </nav> */}
            </div>

            <div>
              <h1 className="text-2xl font-semibold text-white text-left">Important Links</h1>
              <nav className="flex flex-col justify-start mt-4 space-y-2 text-white">
                <h1 onClick={() => gotoPage2("practiceareas")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Practice Areas</h1>
                <h1 onClick={() => gotoPage2("sectors")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Sectors</h1>
                <h1 onClick={() => gotoPage2("expertise")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Expertise</h1>
                {/* <h1 onClick={() => gotoPage2("")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Partners</h1>
                <h1 onClick={() => gotoPage2("")} className="hover:text-[#CB9B2D] text-lg cursor-pointer">Pro Bono</h1> */}
              </nav>
            </div>

            <div>
              <h1 className="text-2xl font-semibold text-white">Contact</h1>
              <nav className="flex flex-col mt-4 space-y-2 text-base text-white">
                <a href="mailto:connect@happyplus.in">Mail: connect@happyplus.in</a>
                <p>
                  Address: HappyPlus Consulting Pvt. Ltd. Express Zone, Western Express Highway, Malad East, Mumbai - 400097
                </p>
                {/* <div className="flex pt-4 space-x-4 text-white flex-wrap">
                <a
                  href="https://www.facebook.com/people/Happy-Consulting/100075972534354/#"
                  target="_blank" rel="noreferrer"
                  className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#CB9B2D] hover:bg-[#CB9B2D] group"
                >
                  <FaFacebookF className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                </a>
                <a
                  href="https://www.linkedin.com/company/happy-consultancy/posts/?feedView=all"
                  target="_blank" rel="noreferrer"
                  className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#CB9B2D] hover:bg-[#CB9B2D] group"
                >
                  <FaLinkedinIn className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                </a>
                <a
                  href="https://www.instagram.com/happyplus_consulting/"
                  target="_blank" rel="noreferrer"
                  className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#CB9B2D] hover:bg-[#CB9B2D] group"
                >
                  <FaInstagram className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UCqobi-Qguom35WNs_kI5dvA"
                  target="_blank" rel="noreferrer"
                  className="bg-white p-2 rounded-lg flex items-center border border-gray-300 justify-center transition-all duration-500 hover:border-[#CB9B2D] hover:bg-[#CB9B2D] group"
                >
                  <FaYoutube className="w-5 h-5 text-[#212121] group-hover:text-white transition-all duration-500" />
                </a>
              </div> */}
              </nav>
            </div>
          </div>
        </div>

        <div className="flex justify-center items-center border-t border-[#757575]">
          <p className="mt-6 text-base text-white">All rights reserved | Copyright © 2024 Agrpartners.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
